module.exports = __webpack_public_path__ + "static/Lokalzeit_Bonn-5b72f369d5b6124b34eff92cac55e7b4.mp4";